onReady(($) => {
    if ($(".cta-banner .video-active")) {
        $('.cta-banner .watch-video')
            .click(function (e) {
                e.preventDefault()
                $(this)
                    .parents(".cta-banner")
                    .find("img")
                    .click();
            });
    }

    const ctaBanners = Array.from(document.querySelectorAll('.cta-banner'))
    for (const ctaBanner of ctaBanners) {
        const ctaButtons = Array.from(ctaBanner.querySelectorAll('.cta-button'))
        for (const ctaButton of ctaButtons) {
            ctaButton.addEventListener('click', (event) => submitCtaClickEvent(event, ctaButton, ctaBanner))
        }
    }
});
